import { TextField, Button } from '@mui/material';
import { otpInputSx } from './LoginHelper.js';

export const OtpInputs = ({ otp, otpError, otpRefs, onChange, onKeyDown, onPaste }) => (
    <div className="otp-inputs" onPaste={onPaste}>
        {otp.map((digit, i) => (
            <TextField key={i} inputRef={(el) => (otpRefs.current[i] = el)}
                value={digit}
                onChange={(e) => onChange(i, e.target.value)}
                onKeyDown={(e) => onKeyDown(i, e)}
                inputProps={{ maxLength: 1, inputMode: 'numeric' }}
                className="otp-input-field"
                sx={otpInputSx(digit, otpError)}
            />
        ))}
    </div>
);

export const MethodCard = ({ value, label, desc, Icon, selected, onSelect }) => (
    <div onClick={() => onSelect(value)} className={`method-card ${selected ? 'method-card--selected' : ''}`}>
        <div className={`method-card__icon ${selected ? 'method-card__icon--selected' : ''}`}>
            <Icon className="method-card__icon-svg" />
        </div>
        <div className="method-card__info">
            <p className="method-card__label">{label}</p>
            <p className="method-card__desc">{desc}</p>
        </div>
        <div className={`method-card__radio ${selected ? 'method-card__radio--selected' : ''}`}>
            {selected && <div className="method-card__radio-dot" />}
        </div>
    </div>
);

export const PrimaryButton = ({ children, onClick, disabled, className = '' }) => (
    <Button variant="contained" fullWidth onClick={onClick} disabled={disabled}
        className={`primary-btn ${className}`}
    >
        {children}
    </Button>
);

export const BackButton = ({ onClick, label = '← Back' }) => (
    <Button variant="text" onClick={onClick} className="back-btn">{label}</Button>
);

export const MethodBadge = ({ method }) => (
    <span className="method-badge">
        {method === 'sms' ? 'SMS' : method === 'email' ? 'Email' : 'Authenticator'}
    </span>
);

export const OtpError = ({ message }) => message
    ? <p className="otp-error">⚠ {message}</p>
    : null;